import { render, staticRenderFns } from "./UseButton.vue?vue&type=template&id=b95cd6b6&"
import script from "./UseButton.vue?vue&type=script&lang=js&"
export * from "./UseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UseButton.vue"
export default component.exports